import { Environments } from "./constants";

// Extend the Window interface to include AvaAppConfig
declare global {
    interface Window {
        AvaAppConfig?: {
            env?: Environments;
            hostnames?: {
                identity?: string;
                avatax?: string;
                avaApp?: string;
            };
            /** Optional shell override for the Global Imports opt-in (`"true"` to enable). */
            VITE_ENABLE_GLOBAL_IMPORTS?: string;
            [key: string]: unknown;
        };
    }
}

const isOneWebDomainRuntime = (): boolean => {
    return !!window.AvaAppConfig;
};

export default isOneWebDomainRuntime;
